export default __webpack_public_path__ + "static/media/feedback-icon.019719b9.svg";